import React from 'react';
import styles from './Spinner.module.css';

const Spinner = ({ 
  size = 'medium', 
  color = 'primary',
  text = '',
  centered = false,
  overlay = false 
}) => {
  const spinnerClasses = [
    styles.spinner,
    styles[size],
    styles[color],
    centered && styles.centered
  ].filter(Boolean).join(' ');

  const content = (
    <div className={spinnerClasses}>
      <div className={styles.circle} />
      {text && <span className={styles.text}>{text}</span>}
    </div>
  );

  if (overlay) {
    return (
      <div className={styles.overlay}>
        {content}
      </div>
    );
  }

  return content;
};

export default Spinner;